import { Directive, OnDestroy, OnInit } from '@angular/core';
import { Subscription, filter, startWith, tap } from 'rxjs';

import { AlertsService } from './alerts.service';
import { IAlert } from './alerts.interfaces';

@Directive()
export abstract class BaseAlertsOutletComponent implements OnInit, OnDestroy {
  protected subscription = new Subscription();

  constructor(protected readonly service: AlertsService) { }

  ngOnInit(): void {
    const queueSub = this.service.showAlert$
      .pipe(
        // Replay alerts raised before this outlet existed. `showAlert$` is a plain
        // Subject, so an alert added during bootstrap (e.g. the "session expired" error
        // raised when an APP_INITIALIZER's session load 401s and logs out) would
        // otherwise never be shown on the login page. `queue` only holds alerts not yet
        // dismissed.
        startWith(...this.service.queue),
        filter((show) => {
          if (show === null) {
            this.dismissAllAlerts();
            return false;
          }

          return true;
        }),
        tap((alert) => {
          if (!alert) {
            return;
          }

          this.showAlert(alert);
        }),
      )
      .subscribe();

    this.subscription.add(queueSub);

    const dismissSub = this.service.dismissAlert$
      .subscribe((id) => {
        this.dismissById(id);
      })
    this.subscription.add(dismissSub);
  }

  dismissById(id: string): void {
    console.log('dimiss by id from base service', id);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  abstract showAlert(alert: IAlert): void;
  abstract dismissAllAlerts(): void;
}
